const hook = {
    missing_events: 'يجب أن تقدم على الأقل حدث واحد.',
    send_test_payload_failed: 'فشل في إرسال حمولة الاختبار: {{message}}',
    endpoint_responded_with_error: 'ردت النقطة النهائية بخطأ.',
};
export default Object.freeze(hook);
